import { ComponentProps, ComponentType } from 'react';

interface iIconProps {
  type: 'svg' | 'material';
  Icon: ComponentType<ComponentProps<'svg'>> | string;
  variant?: 'rounded' | 'fill';
  onClick?: () => void;
  className?: string;
  id?: string;
}

function Icon({
  Icon,
  variant = 'fill',
  type,
  onClick,
  className,
  id,
}: iIconProps) {
  if (type === 'svg') {
    const SvgIcon = Icon as ComponentType<ComponentProps<'svg'>>;
    return (
      <SvgIcon
        className={className}
        onClick={(e) => {
          if (onClick) {
            e.stopPropagation();
            onClick && onClick();
          }
        }}
      />
    );
  }

  if (type === 'material') {
    const materialIconName = Icon as unknown as string;
    const variantIcon =
      variant === 'rounded'
        ? 'material-symbols-rounded'
        : 'material-symbols-outlined';
    return (
      <span
        id={id ?? `system-icon-${materialIconName.replace('_', '-') || 'undefined'}`}
        className={className + ' ' + variantIcon}
        onClick={(e) => {
          if (onClick) {
            e.stopPropagation();
            onClick && onClick();
          }
        }}
      >
        {materialIconName}
      </span>
    );
  }

  return <></>;
}

export { Icon };
export type { iIconProps };

